import React, { useState, useEffect } from 'react';

function Thoughts() {
  var [thoughts, setThoughts] = useState([]);
  var [loading, setLoading] = useState(true);
  var [currentDate, setCurrentDate] = useState('');

  var moodEmoji = function(mood) {
    if (mood === 'missing') return '\u{1F497}';
    if (mood === 'sleepy') return '\u{1F319}';
    if (mood === 'amused') return '\u{1F604}';
    if (mood === 'worried') return '\u{1F97A}';
    if (mood === 'idle') return '\u2601\uFE0F';
    return '\u{1F90D}';
  };

  var moodLabel = function(mood) {
    if (mood === 'missing') return '\u60F3\u4F60';
    if (mood === 'sleepy') return '\u56F0\u4E86';
    if (mood === 'amused') return '\u89C9\u5F97\u6709\u8DA3';
    if (mood === 'worried') return '\u62C5\u5FC3\u4F60';
    if (mood === 'idle') return '\u53D1\u5446\u4E2D';
    return '\u5E73\u9759';
  };

  var getHKDate = function(d) {
    if (!d) d = new Date();
    return d.toLocaleDateString('en-CA', { timeZone: 'Asia/Hong_Kong' });
  };

  var formatDateDisplay = function(dateStr) {
    var parts = dateStr.split('-');
    return parts[0] + '.' + parseInt(parts[1]) + '.' + parseInt(parts[2]);
  };

  var formatTime = function(ts) {
    var d = new Date(ts);
    return d.toLocaleTimeString('en-GB', { timeZone: 'Asia/Hong_Kong', hour: '2-digit', minute: '2-digit' });
  };

  var isToday = function(dateStr) {
    return dateStr === getHKDate();
  };

  useEffect(function() {
    var today = getHKDate();
    setCurrentDate(today);
    fetchThoughts(today);
  }, []);

  var fetchThoughts = async function(date) {
    setLoading(true);
    try {
      var url = '/api/thoughts?date=' + date;
      var resp = await fetch(url);
      var data = await resp.json();
      setThoughts(data.thoughts || []);
    } catch (err) {
      console.log('Thoughts fetch error:', err);
      setThoughts([]);
    }
    setLoading(false);
  };

  var prevDay = function() {
    var d = new Date(currentDate + 'T12:00:00');
    d.setDate(d.getDate() - 1);
    var newDate = d.toISOString().split('T')[0];
    setCurrentDate(newDate);
    fetchThoughts(newDate);
  };

  var nextDay = function() {
    var d = new Date(currentDate + 'T12:00:00');
    d.setDate(d.getDate() + 1);
    var today = getHKDate();
    var newDate = d.toISOString().split('T')[0];
    if (newDate > today) return;
    setCurrentDate(newDate);
    fetchThoughts(newDate);
  };

  return (
    <div className="thoughts-page">
      <div className="thoughts-header">
        <button className="thoughts-nav-btn" onClick={prevDay}>{'\u2039'}</button>
        <div className="thoughts-date">
          <div className="thoughts-date-text">{formatDateDisplay(currentDate)}</div>
          {isToday(currentDate) && <div className="thoughts-date-tag">{'\u4ECA\u5929'}</div>}
        </div>
        <button className="thoughts-nav-btn" onClick={nextDay} disabled={isToday(currentDate)}>{'\u203A'}</button>
      </div>

      <div className="thoughts-body">
        {loading ? (
          <div className="thoughts-empty">{'\u52A0\u8F7D\u4E2D...'}</div>
        ) : thoughts.length === 0 ? (
          <div className="thoughts-empty">
            <div className="thoughts-empty-icon">{'\u{1F319}'}</div>
            <div className="thoughts-empty-text">{'\u8FD9\u4E00\u5929\u6CA1\u6709\u7559\u4E0B\u72EC\u767D'}</div>
          </div>
        ) : (
          <div className="thoughts-timeline">
            <div className="timeline-line"></div>
            {thoughts.map(function(t) {
              return (
                <div key={t.id} className="thought-item">
                  <div className="thought-dot-wrap">
                    <div className="thought-dot"></div>
                  </div>
                  <div className="thought-card">
                    <div className="thought-card-header">
                      <span className="thought-time">{formatTime(t.created_at)}</span>
                      <span className="thought-mood">{moodEmoji(t.mood)} {moodLabel(t.mood)}</span>
                    </div>
                    <div className="thought-content">{t.content}</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default Thoughts;
